import { Component } from '@angular/core';
import { Nav,NavController, NavParams, AlertController, ToastController, LoadingController, MenuController, Events } from 'ionic-angular';

import { UserMyRadiant as User, User as UserProject, HelperMyRadiant,LoginMyRadiant  } from '../../../providers';
import { User as UserAdvance } from '../../../providers/advance_providers';

import { HomePage } from '../';
import { TabsPage } from '../tabs/tabs';
import { AppPresensi } from "../../../pages/presensi";
import { AppActivity } from "../../../pages/activity";

@Component({
  selector: 'page-login-myradiant',
  templateUrl: 'page.html'
})
export class LoginPage {

  form={
    username:'',
    password:''
  };
  loading:any;

  constructor(
    public  navCtrl      : NavController,
    public  navParams    : NavParams,
    private menuCtrl     : MenuController,
    private toastCtrl    : ToastController,
    public  loadingCtrl  : LoadingController,
    public  events       : Events,
    public  userApi      : User,
    public  nav          : Nav,
    public  userProject  : UserProject,
    public  loginProvider: LoginMyRadiant,
    public  helper       : HelperMyRadiant
  ) {
    // console.log(this.userProject);
  }

  ionViewWillEnter() {
    let mainPage = localStorage.getItem("mainPage");
    if(localStorage.form_login!=undefined){
      localStorage.setItem("mainPage", mainPage);
      this.doLogin(1);
    }else{      
      // let myItem = localStorage.getItem('stateLoadBerita');
      localStorage.clear();
      localStorage.setItem("mainPage", mainPage);
      // localStorage.setItem('stateLoadBerita',myItem);
      this.menuCtrl.enable(false, 'MainMenu');
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  backNews(){
    this.nav.setRoot(TabsPage,{
      tabIndex : 0,
    });
    this.events.publish('user:want_sign_out');
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  doLogin(check=0){
    let me = this;
    this.showLoading();
    let pathPage = {
      '/apps-presensi': {
        modul: AppPresensi,
        modulid: 2
      },
      "/apps-activity": {
        modul: AppActivity,
        modulid: 8
      }
    },
    modul_akses = [];
    if(check){
      this.form = JSON.parse(localStorage.form_login);
    }
    let params = this.form;

    this.userApi.login(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      if ("modul_akses" in resp) {
        modul_akses = resp["modul_akses"];
      }      
      let akses = [];      
      this.loading.dismiss();
      // console.log("Akses 1", modul_akses);
      // console.log(localStorage.getItem("mainPage"));
      if(resp.success){
        localStorage.is_login=1;
        localStorage.form_login=JSON.stringify(this.form);
        localStorage.data_user=JSON.stringify(resp);
        this.loginProvider.setSession();
        this.menuCtrl.enable(true, 'MainMenu');     

        if (localStorage.getItem("mainPage") in pathPage) {   
          let rootPage = pathPage[localStorage.getItem("mainPage")];
          if (modul_akses.length > 0) {
            akses = modul_akses.filter(function (row) {
              if (row.id == rootPage["modulid"] && row.hak_akses == 1) {
                return row;
              }
            });            
          } 
          // console.log("Akses",akses);
          if (akses && akses.length > 0) {
            this.nav.setRoot(rootPage["modul"]);
          } else {
            this.helper.presentToast("You don't have access to this feature");
            setTimeout(() => {              
              me.nav.setRoot(TabsPage,{tabIndex: 2});
            }, 500);
          }        
        } else {
          this.nav.setRoot(TabsPage, { tabIndex: 2 });
        }

      }
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });    
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/login/page.ts